import { SvgIcon, SvgIconProps } from "@mui/material";

export function ProductContentOpeningHoursIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M12 0C5.36761 0 0 5.36705 0 12C0 18.6324 5.36705 24 12 24C18.6323 24 24 18.633 24 12C24 5.36766 18.633 0 12 0ZM14.4739 13.3604H11.0587C10.617 13.3604 10.2587 13.0022 10.2587 12.5603V7.30463C10.2587 6.86283 10.6169 6.50461 11.0587 6.50461C11.5006 6.50461 11.8588 6.86278 11.8588 7.30463V11.7604H14.4739C14.9157 11.7604 15.2739 12.1185 15.2739 12.5604C15.2739 13.0022 14.9157 13.3604 14.4739 13.3604Z" />
        </SvgIcon>
    );
}
